// initial state
const state = {
  all: null,
  error: 0
}

// getters
const getters = {
  guildhistory: state => state.all
}

// actions
const actions = {
  getGuildHistory ({ commit }, data) {
    commit('setGuildHistory', data)
  },
  setError ({commit}, data) {
    commit('setError', data.data)
  }
}

// mutations
const mutations = {
  setGuildHistory (state, all) {
    state.all = all
  },
  setError (state, error) {
    state.error = {error: error, time: Date.now()}
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
